import React from "react";

export const SuccessMessage = () => {

    return (
            <div className="success">
                <p>Your link has been successfully copied</p>
            </div>
    )
}

